import React, { useState, Fragment, useEffect } from 'react';
import Img from "../../images/mail.png";
import { toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"
import { clearErrors, forgotPasswordAction } from "../../../redux/actions/userActions"
import Loader from '../../loader/loader';
import { FORGET_PASSWORD_RESET } from '../../../redux/constants/userConstant';

const VerifyEmail = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { loading, error, message, } = useSelector((state) => state.forgotPassword);
    const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

    const [email, setEmail] = useState("")

    useEffect(() => {

        setEmail(localStorage.getItem("email"))

        document.title = `FORGOT PASSWORD`;

    }, [])




    const resend = (e) => {
        if (!email) {
            toast.error("Credentials lost please forgot the password again")
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }


        const userData = {
            email,
        }

        dispatch(forgotPasswordAction(userData))
    }


    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            toast.info(message)
            dispatch({ type: FORGET_PASSWORD_RESET })
        }

        if (isAuthenticated) {
            navigate('/')
        }

    }, [error, message, dispatch, isAuthenticated, navigate])



    return (
        <Fragment>
            {loading ? <Loader /> :
                <section className="min-h-screen w-full bg-[#F8FAFC] flex items-center justify-center p-4 relative overflow-hidden font-jakarta">
                    {/* Subtle Background Decorations */}
                    <div className="absolute top-[-20%] left-[-10%] w-[40vmax] h-[40vmax] bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full filter blur-3xl opacity-70"></div>
                    <div className="absolute bottom-[-20%] right-[-10%] w-[40vmax] h-[40vmax] bg-gradient-to-tl from-purple-50 to-pink-50 rounded-full filter blur-3xl opacity-70"></div>

                    <div className="relative z-10 max-w-lg w-full bg-white border border-zinc-100 rounded-3xl p-10 shadow-[0_20px_50px_rgba(0,0,0,0.05)] flex flex-col items-center text-center">
                        
                        {/* Icon Container */}
                        <div className="mb-8 relative">
                            <div className="absolute inset-0 bg-blue-50 rounded-full scale-110 animate-pulse"></div>
                            <div className="relative w-20 h-20 bg-white rounded-full shadow-md flex items-center justify-center border border-zinc-50">
                                <img src={Img} alt="email" className="w-10 h-10 object-contain" />
                            </div>
                        </div>

                        {/* Heading */}
                        <h1 className="text-3xl font-bold text-zinc-900 mb-3 tracking-tight">
                            Check your email
                        </h1>

                        {/* Description */}
                        <p className="text-zinc-500 text-base mb-6 max-w-sm">
                            We've sent a password reset link to <br />
                            <span className="font-semibold text-zinc-800">{email}</span>
                        </p>

                        {/* Action Buttons */}
                        <div className="w-full space-y-3 mb-8">
                            <button 
                                className="w-full bg-zinc-900 text-white font-medium py-3 rounded-xl hover:bg-zinc-800 transition-all duration-200 shadow-sm"
                                onClick={() => window.open('https://gmail.com', '_blank')}
                            >
                                Open Email App
                            </button>
                            
                            <button 
                                className="w-full bg-white text-zinc-700 font-medium py-3 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all duration-200"
                                onClick={resend}
                            >
                                Resend Email
                            </button>
                        </div>

                        {/* Footer */}
                        <div className="text-sm text-zinc-500">
                            Didn't receive the email? Check your spam folder or{" "}
                            <button className="text-zinc-900 font-semibold hover:underline" onClick={resend}>
                                try again
                            </button>
                        </div>

                        <div className="mt-8 pt-6 border-t border-zinc-100 w-full">
                            <Link to="/login" className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors inline-flex items-center gap-2 justify-center">
                                <i className="fa-solid fa-arrow-left text-xs"></i>
                                Back to Login
                            </Link>
                        </div>
                    </div>
                </section>
            }
        </Fragment>

    );
};

export default VerifyEmail;
